/* @flow */

import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class AddNewSystemSuccess extends React.Component<*> {
  componentDidMount() {
    const { actionDrawerStore, accountStore, config }: TypeProps = this.props;
    const LOCATION_COLUMN_SYSTEM = 4;

    if (typeof accountStore.locationLists[5] === 'string') {
      accountStore.locationLists[5] = [{ active: [] }];
    }

    accountStore.locationLists[5][0].active.push(actionDrawerStore.response);

    actionDrawerStore.locationColumn = LOCATION_COLUMN_SYSTEM;
    actionDrawerStore.closeActionDrawer();
  }

  render(): React.Element<*> {
    return 'success';
  }
}
